import React, { useEffect, useState } from "react";
import "../../styles/Email/EmailTemplate.css";
import Card from "../Common/EmailCard";
import { AiOutlineSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import UnifiedDocumentModal from "../Common/UnifiedDocumentModal";
import Breadcrumb from "../Common/Bredcrump";
import axiosInstance from "../../utils/api";
import Loader from "../Common/Loader";

const token = localStorage.getItem("token");

const EmailTemplates = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [filterCategory, setFilterCategory] = useState("all");
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showCreateEmailLeft, setCreateEmailLeft] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [selectedTemplatePreview, setSelectedTemplatePreview] = useState("");
  const [selectedkey, setSelectedKey] = useState("");
  const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
  const [selectedPreviewImage, setSelectedPreviewImage] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageLimit] = useState(9); // fixed limit per page
  const [total, setTotal] = useState(0);

  const handleUseTemplate = (name, previewUrl, emailId, image, previewImage) => {
    setSelectedTemplateName(name);
    setSelectedTemplatePreview(previewUrl);
    setSelectedKey(emailId);
    setSelectedTemplateImage(image);
    setSelectedPreviewImage(previewImage);
    setShowDocumentModal(true);
  }
  useEffect(() => {
    if (selectedTemplateName) {
      setCreateEmailLeft(true);
    }
  }, [selectedTemplateName]);

  const handleNext = () => {
    navigate("/skills/email/create-email");
  }
  // Filter the current page data (search is handled by API via query_str)
  const filteredTemplates = (templates || [])
    .filter((template) => {
      if (!template.name) return false;
      const matchesCategory = filterCategory === "all" || template.name === filterCategory;
      return matchesCategory;
    })
    .sort((a, b) => {
      const aValue = a[sortBy] ? a[sortBy].toString().toLowerCase() : "";
      const bValue = b[sortBy] ? b[sortBy].toString().toLowerCase() : "";
      return aValue.localeCompare(bValue);
    });
  const categories = [
    "all",
    ...new Set(templates.map((template) => template.name)),
  ];

  const fetchTemplates = async (pageNumber = 1, pageLimit = 10, folderId = 782507, queryStr = "") => {
    try {
      setLoading(true); 
  
      let apiUrl = `api/v1/fetch_emails?page_limit=${pageLimit}&page_number=${pageNumber}&folder_id=${folderId}`;
      if (queryStr) {
        apiUrl += `&query_str=${encodeURIComponent(queryStr)}`;
      }
  
      const response = await axiosInstance.get(
        apiUrl,
        {
          headers: {
            Authorization: token,
          },
        }
      );
  
      const dataToSet = Array.isArray(response.data.data) ? response.data.data : [];
      const totalCount = response.data.total ? response.data.total : 0;
  
      setTemplates(dataToSet);
      setTotal(totalCount);
    } catch (err) {
      setError("Failed to load templates.");
    } finally {
      setLoading(false); // Stop loading whether success or error
    }
  };
  

  // Re-fetch data whenever pageNumber, pageLimit, or searchTerm changes
  useEffect(() => {
    fetchTemplates(pageNumber, pageLimit, 782507, searchTerm);
    localStorage.removeItem("last_saved_draft_id");
  }, [pageNumber, pageLimit, searchTerm]);

  // Calculate total pages
  const totalPages = Math.ceil(total / pageLimit);

  return (
    <div className="container-fluid">
      <div className="email-templates m-0 p-2">
        <Breadcrumb />

        <h1 className="mt-3">Email templates</h1>


        <div className="controls mt-3">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Template name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <AiOutlineSearch className="search-icon" />
          </div>

          <div className="actions">
            <select
              className="filter-select"
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </option>
              ))}
            </select>

            <select
              className="sort-select"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="title">Sort by Title</option>
              <option value="category">Sort by Category</option>
            </select>
          </div>
        </div>
        <hr></hr>
        {loading &&
        <div className="loader-container">
        <Loader />
        </div>
        }
        <div className="templates-grid">
       
          {filteredTemplates.map((template) => (
            <Card
              key={template.emailId}
              name={template.name}
              description={template.title}
              previewUrl={template.previewUrl}
              image={template.image}
              previewImage={template.previewImage}
              emailId={template.emailId}
              handleUseTemplate={() => handleUseTemplate(template.name, template.previewUrl, template.emailId, template.image, template.previewImage)}
            />
          ))}
        </div>
        {/* Pagination Controls */}
        <div className="pagination-controls" style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px",
          gap: "12px",
          fontFamily: "sans-serif"
        }}>
          <button
            onClick={() => setPageNumber((prev) => Math.max(prev - 1, 0))}
            disabled={pageNumber === 0}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              backgroundColor: pageNumber === 0 ? "#e5e7eb" : "#dc2626",
              color: pageNumber === 0 ? "#6b7280" : "#fff",
              border: "none",
              cursor: pageNumber === 0 ? "not-allowed" : "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
          >
            ⬅ Previous
          </button>

          <span style={{ fontWeight: 500, color: "#374151" }}>
            Page {pageNumber + 1} of {totalPages}
          </span>

          <button
            onClick={() => setPageNumber((prev) => (prev < totalPages - 1 ? prev + 1 : prev))}
            disabled={pageNumber === totalPages - 1}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              backgroundColor: pageNumber === totalPages - 1 ? "#e5e7eb" : "#dc2626",
              color: pageNumber === totalPages - 1 ? "#6b7280" : "#fff",
              border: "none",
              cursor: pageNumber === totalPages - 1 ? "not-allowed" : "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
          >
            Next ➡
          </button>
        </div>
      </div>


      <UnifiedDocumentModal
        show={showDocumentModal}
        sku={selectedTemplateName}
        templateName={selectedTemplateName}
        previewUrl={selectedTemplatePreview}
        templateId={selectedkey}
        onHide={() => setShowDocumentModal(false)}
        handleNext={handleNext}
        image={selectedTemplateImage}
        previewImage={selectedPreviewImage}
      />
    </div>

  );
};

export default EmailTemplates;
